import Vue from 'vue'
import VueToastify from "vue-toastify";

require('../bootstrap');

window.Vue = Vue
Vue.use(VueToastify);
Vue.component('register', require('../components/user/Register').default);
new Vue({
    el: '#register',
});
